import * as React from "react";
type Props = {
  className?: string,
};
function SvgCalendar2({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-Calendar2"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.58333 1.33398C8.04357 1.33398 8.41667 1.70708 8.41667 2.16732V3.00065H12.5833V2.16732C12.5833 1.70708 12.9564 1.33398 13.4167 1.33398C13.8769 1.33398 14.25 1.70708 14.25 2.16732V3.00065H15.6852C16.9636 3.00065 18 4.03703 18 5.31547V15.6858C18 16.9643 16.9636 18.0007 15.6852 18.0007H5.31481C4.03638 18.0007 3 16.9643 3 15.6858V5.31547C3 4.03703 4.03638 3.00065 5.31481 3.00065H6.75V2.16732C6.75 1.70708 7.1231 1.33398 7.58333 1.33398ZM6.75 4.66732H5.31481C4.95685 4.66732 4.66667 4.9575 4.66667 5.31547V8.00065H16.3333V5.31547C16.3333 4.9575 16.0431 4.66732 15.6852 4.66732H14.25V5.50065C14.25 5.96089 13.8769 6.33398 13.4167 6.33398C12.9564 6.33398 12.5833 5.96089 12.5833 5.50065V4.66732H8.41667V5.50065C8.41667 5.96089 8.04357 6.33398 7.58333 6.33398C7.1231 6.33398 6.75 5.96089 6.75 5.50065V4.66732ZM16.3333 9.66732H4.66667V15.6858C4.66667 16.0438 4.95685 16.334 5.31481 16.334H15.6852C16.0431 16.334 16.3333 16.0438 16.3333 15.6858V9.66732Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgCalendar2;
